import stateQuarterImages from "../../data/stateQuarterImages.json";

export default function StateQuarterGallery({ stateCode }) {
  const info = stateQuarterImages[stateCode];
  if (!info) return null;

  return (
    <figure className="sq-quarter-card">
      {info.src ? (
        <img
          src={info.src}
          alt={`${info.name} state quarter (${info.year})`}
          className="sq-quarter-img"
          loading="lazy"
          decoding="async"
        />
      ) : (
        <div className="sq-quarter-placeholder" aria-hidden="true">
          <span className="sq-quarter-placeholder-code">{stateCode}</span>
          <span className="sq-quarter-placeholder-year">{info.year}</span>
        </div>
      )}
      <figcaption className="sq-quarter-caption">
        <strong>{info.year}</strong>
        <span>{info.design}</span>
        <span className="sq-quarter-credit">{info.credit}</span>
      </figcaption>
    </figure>
  );
}
